import * as symbols from "../../symbols";

export default function () {
    Array.prototype[symbols.isEmpty] = function () {
        return !this || this.length === 0;
    };
}
